<template>
  <v-container fluid class="mb-10">
    <v-card elevation="0" color="transparent">
      <v-row justify="center">
        <v-col cols="12" sm="3">
          <v-card class="mx-auto" tile elevation="1" outlined>
            <v-list dense disabled>
              <v-list-item>
                <v-list-item-icon class="mr-3">
                  <v-icon>mdi-code-braces-box</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="mt-1">
                  {{ $store.state.store.store.store_name }}
                </v-list-item-title>
              </v-list-item>
              <v-list-group
                v-model="item"
                no-action
                value="true"
                append-icon=""
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon size="20" class="ml-3">
                        mdi-chevron-right
                      </v-icon>
                      Store Email Details
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-group>
            </v-list>
            <v-row dense no-gutters align="center">
              <v-col class="text-center">
                <v-btn
                  v-if="tabs === 'tab-4'"
                  v-show="json"
                  outlined
                  class="mb-2"
                  color="success"
                  elevation="1"
                  :disabled="!change_something"
                  @click="done()"
                >
                  <v-icon class="mr-2"> mdi-check-outline </v-icon>
                  {{ $t("store.update") }}
                </v-btn>
                <v-btn
                  v-else-if="tabs === 'tab-1'"
                  class="mb-2"
                  color="success"
                  @click="change_email"
                  :disabled="content && selected && lang ? false : true"
                  :dark="content && selected && lang ? true : false"
                >
                  <v-icon class="mr-2"> mdi-check-outline </v-icon>
                  {{ $t("store.update") }}
                </v-btn>
                <v-btn
                  v-else-if="tabs === 'tab-2'"
                  class="mb-2"
                  color="success"
                  :disabled="
                    cc && cc.BrandEmail && cc.active !== undefined
                      ? false
                      : true
                  "
                  :dark="
                    cc && cc.BrandEmail && cc.active !== undefined
                      ? true
                      : false
                  "
                  @click="update_cc"
                >
                  <v-icon class="mr-2"> mdi-check-outline </v-icon>
                  {{ $t("store.update") }}
                </v-btn>
                <v-btn
                  v-else-if="tabs === 'tab-3'"
                  class="mb-2"
                  color="success"
                  @click="saveBoxEmailConfig"
                  :disabled="
                    !valid ||
                    (boxEmailContent &&
                      boxEmailContent.content &&
                      !boxEmailContent.content.length)
                  "
                  :dark="
                    boxEmailContent &&
                    boxEmailContent.content &&
                    !boxEmailContent.content.length
                      ? true
                      : false
                  "
                >
                  <v-icon class="mr-2"> mdi-check-outline </v-icon>
                  {{ $t("store.update") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col>
          <v-card :loading="loading" elevation="0">
            <v-tabs
              v-model="tabs"
              background-color="primary darken-1"
              dark
              centered
              icons-and-text
              @change="handleOnTabChange"
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab href="#tab-1" class="font-weight-black">
                Email Content
              </v-tab>

              <v-tab href="#tab-2" class="font-weight-black"> CC edit </v-tab>
              <v-tab href="#tab-3" class="font-weight-black">
                Box email configuration
              </v-tab>
              <v-tab
                :disabled="!$store.state.admin.super_actions"
                href="#tab-4"
                class="font-weight-black"
              >
                Admin Details
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item value="tab-1">
                <v-row justify="center" align="center">
                  <v-col cols="12">
                    <v-row justify="center" align="center" dense no-gutters>
                      <v-col cols="11" sm="8">
                        <v-select
                          :menu-props="{ bottom: true, offsetY: true }"
                          v-model="selected"
                          :items="email_types"
                          label="Select email type :"
                          solo
                          @change="select_type"
                        ></v-select>
                      </v-col>
                      <v-col cols="11" sm="8">
                        <v-select
                          :menu-props="{ bottom: true, offsetY: true }"
                          v-model="lang"
                          :items="langs"
                          label="Select email lang."
                          solo
                          @change="select_lang"
                          v-show="selected"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row justify="center" dense>
                      <v-col
                        v-if="contentSet && email_type_hint"
                        cols="10"
                        class="mb-2"
                      >
                        <v-alert type="info" outlined>
                          <div v-html="email_type_hint"></div>
                        </v-alert>
                      </v-col>
                      <v-col cols="8">
                        <v-text-field
                          v-if="contentSet"
                          v-model="fromText"
                          label="From text subject"
                          placeholder="From..."
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="8">
                        <v-text-field
                          v-if="contentSet"
                          v-model="subject"
                          label="Email Subject"
                          placeholder="Subject..."
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <VueEditor
                          v-if="contentSet"
                          v-model="content"
                          :editorToolbar="customToolbar"
                          class="editor-vue-html"
                      /></v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="tab-2">
                <v-card outlined class="mb-6">
                  <v-card-text>
                    <v-row justify="center" align="center" dense no-gutters>
                      <v-col cols="11" sm="8">
                        <v-select
                          :menu-props="{ bottom: true, offsetY: true }"
                          v-model="selected"
                          :items="email_types"
                          label="Select email type :"
                          solo
                          @change="select_type_cc"
                        ></v-select>
                      </v-col>
                      <v-col cols="11" sm="8" v-if="cc">
                        <v-text-field
                          v-model="cc.BrandEmail"
                          label="cc:"
                          placeholder="email, ..., ..."
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center" dense v-if="cc">
                      <v-col cols="12">
                        <v-row justify="center" align="center" dense no-gutters>
                          <v-col cols="auto">
                            <v-checkbox
                              v-model="cc.active"
                              :label="`Send copy to Brand : ${cc.active}`"
                              color="red"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="tab-3">
                <v-form v-model="valid" ref="form">
                  <v-card outlined class="mb-6">
                    <v-card-text>
                      <v-row justify="center" align="center" dense no-gutters>
                        <v-col cols="11" sm="8">
                          <v-text-field
                            v-model="boxEmailContent.to"
                            label="Send email to"
                            placeholder="Email..."
                            outlined
                            :rules="[
                              (v) => !!v || 'Send to email field is required',
                              (v) =>
                                /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) ||
                                'Invalid e-mail',
                            ]"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="8">
                          <v-text-field
                            v-model="boxEmailContent.subject"
                            label="Subject"
                            placeholder="Email Subject..."
                            outlined
                            :rules="[(v) => !!v || 'Subject field is required']"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="8">
                          <v-text-field
                            v-model="boxEmailContent.fromText"
                            label="fromText"
                            placeholder="From Text..."
                            outlined
                            :rules="[
                              (v) => !!v || 'From text field is required',
                            ]"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="8">
                          <v-checkbox
                            v-model="boxEmailContent.activate"
                            label="Activate box-email to send emails ?"
                            required
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="11" sm="8">
                          <v-checkbox
                            v-model="boxEmailContent.sendCC"
                            label="Send copy to customer email ?"
                            required
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12">
                          <VueEditor
                            v-model="boxEmailContent.content"
                            :editorToolbar="customToolbar"
                            class="editor-vue-html"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-tab-item>
              <v-tab-item value="tab-4">
                <v-jsoneditor
                  v-model="json"
                  :plus="false"
                  :options="options"
                  height="710px"
                  class="json-part pt-1"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  name: "I18n",
  components: {
    VueEditor,
  },
  data() {
    return {
      valid: true,
      tabs: 0,
      content: undefined,
      subject: undefined,
      fromText: undefined,
      cc: undefined,
      contentSet: false,
      loading: true,
      item: 1,
      change_something: false,
      json: {},
      temp: {},
      options: {
        enableTransform: true,
        modes: ["tree", "code", "text", "view"],
        onChange: this.change,
      },
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link", "image" /*"video"*/],
        ["clean"], // remove formatting button
      ],
      langs: ["fr", "en"],
      lang: undefined,
      selected: undefined,
      boxEmailContent: {
        brand: "",
        subject: "",
        to: "",
        content: "",
        activate: false,
        sendCC: false,
        fromText: "",
      },
    };
  },
  computed: {
    admin_details() {
      const details = this.$store.state.admin.admin_details.details;
      return details;
    },
    email_types() {
      const types = [
        {
          text: this.$t("email_api_details.email_types.answer.name"),
          value: "answer",
          hint: this.$t("email_api_details.email_types.answer.hint"),
        },
        {
          text: this.$t("email_api_details.email_types.transfer.name"),
          value: "transfer",
          hint: this.$t("email_api_details.email_types.transfer.hint"),
        },
        {
          text: this.$t(
            "email_api_details.email_types.transfer_escalation.name"
          ),
          value: "transfer_escalation",
          hint: this.$t(
            "email_api_details.email_types.transfer_escalation.hint"
          ),
        },
        {
          text: this.$t(
            "email_api_details.email_types.transfer_without_email.name"
          ),
          value: "transfer_without_email",
          hint: this.$t(
            "email_api_details.email_types.transfer_without_email.hint"
          ),
        },
        {
          text: this.$t("email_api_details.email_types.transfer_store.name"),
          value: "transfer_store",
          hint: this.$t("email_api_details.email_types.transfer_store.hint"),
        },
      ];
      return types;
    },
    email_type_hint() {
      if (!this.selected) return "";
      const typeObj = this.email_types.find(
        (item) => item.value === this.selected
      );
      return typeObj ? typeObj.hint : "";
    },
  },
  mounted() {
    this.json = this.admin_details;
    this.temp = { ...this.admin_details };
    this.loading = false;
  },
  methods: {
    handleOnTabChange(tab) {
      this.selected = null;
      this.lang = null;
      if (tab === "tab-3") {
        this.boxEmailContent = this.admin_details?.EmailApi
          ?.boxEmailContent || {
          brand: "",
          subject: "",
          to: "",
          content: "",
          fromText: "",
          activate: false,
          sendCC: false,
        };
      } else {
        this.contentSet = false;
      }
      this.cc = null;
    },
    select_type_cc() {
      this.cc = this.admin_details.EmailApi.content[this.selected]?.cc;
    },
    select_type() {
      // console.log("this.admin_details", this.admin_details);
      if (this.lang) {
        this.content = this.admin_details.EmailApi.content[this.selected][
          this.lang
        ].content;
        this.subject = this.admin_details.EmailApi.content[this.selected][
          this.lang
        ].subject;
        this.fromText = this.admin_details.EmailApi.content[this.selected][
          this.lang
        ].fromText;
        this.contentSet = true;
      }
    },
    update_cc() {
      this.$store
        .dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: "Agree to change",
        })
        .then((confirmation) => {
          if (confirmation) {
            const obj = {
              type: this.selected,
              CC: {
                BrandEmail: this.cc.BrandEmail,
                active: this.cc.active,
              },
            };

            this.$store.dispatch("setLoader", {
              showing: true,
              text: "Saving CC email",
            });
            this.$store
              .dispatch("UPDATE_STORE_EMAIL_FORMAT", obj)
              .then((res) => {
                this.$store.dispatch("setLoader", {
                  showing: false,
                  text: "Saving CC email",
                });
                this.$store.dispatch("setSnackbar", {
                  showing: true,
                  text: "Change added",
                  color: "success",
                });
              });
          }
        });
    },
    change_email() {
      this.$store
        .dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: "Agree to change",
        })
        .then((confirmation) => {
          if (confirmation) {
            const obj = {
              data: {
                content: this.content,
                subject: this.subject,
                fromText: this.fromText,
              },
              type: this.selected,
              lang: this.lang,
            };
            this.$store.dispatch("setLoader", {
              showing: true,
              text: "Saving email format",
            });
            this.$store
              .dispatch("UPDATE_STORE_EMAIL_FORMAT", obj)
              .then((res) => {
                this.$store.dispatch("setLoader", {
                  showing: false,
                  text: "Saving data",
                });
                this.$store.dispatch("setSnackbar", {
                  showing: true,
                  text: "Change added",
                  color: "success",
                });
              });
          }
        });
    },
    select_lang() {
      this.content = this.admin_details.EmailApi.content[this.selected][
        this.lang
      ].content;
      this.subject = this.admin_details.EmailApi.content[this.selected][
        this.lang
      ].subject;
      this.fromText = this.admin_details.EmailApi.content[this.selected][
        this.lang
      ].fromText;
      this.contentSet = true;
    },
    change() {
      this.change_something = true;
    },
    done() {
      console.log(this.json);
      if (JSON.stringify(this.json) !== JSON.stringify(this.temp)) {
        this.$store.dispatch("setLoader", {
          showing: true,
          text: "Saving json",
        });
        this.$store
          .dispatch("UPDATE_STORE_EMAIL_DETAILS", this.json)
          .then((res) => {
            this.$store.dispatch("setLoader", {
              showing: false,
              text: "Saving json",
            });
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: "Change added",
              color: "success",
            });
          });
      } else {
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: "No Change Made",
          color: "warning",
        });
        this.change_something = false;
      }
    },
    async saveBoxEmailConfig() {
      this.$store
        .dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: "Agree to change",
        })
        .then((confirmation) => {
          if (confirmation) {
            this.admin_details.EmailApi = {
              ...this.admin_details.EmailApi,
              boxEmailContent: { ...this.boxEmailContent },
            };

            this.$store
              .dispatch("UPDATE_STORE_EMAIL_DETAILS", this.json)
              .then((res) => {
                this.$store.dispatch("setLoader", {
                  showing: false,
                  text: "Saving json",
                });
                this.$store.dispatch("setSnackbar", {
                  showing: true,
                  text: "Change added",
                  color: "success",
                });
              })
              .catch((err) => {
                this.$store.dispatch("setSnackbar", {
                  showing: true,
                  text: err.message || "Error",
                  color: "error",
                });
              });
          }
        });
    },
  },
};
</script>

<style>
.editor-vue-html .ql-container {
  height: 710px !important;
}
.json-part {
  background: #fafafa;
}

.json-part .jsoneditor-menu {
  background: #7b1fa2 !important;
}
.json-part .jsoneditor-menu > button {
  opacity: 1;
}
.json-part .jsoneditor-frame {
  border-radius: 7px;
  border: 1px solid transparent;
  background-color: #fafafa;
  padding: 0 2px;
  margin: 0;
}
.json-part .jsoneditor {
  border-radius: 4px;
  border: 1px solid #7b1fa2;
}
.json-part .jsoneditor-contextmenu .jsoneditor-menu button {
  color: #fafafa;
}
.json-part .jsoneditor-contextmenu .jsoneditor-menu button:hover {
  color: black;
}
.json-part
  .jsoneditor-contextmenu
  .jsoneditor-menu
  li
  button.jsoneditor-selected,
.jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected:focus,
.jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected:hover {
  background: #7283b3;
}
.json-part .jsoneditor-menu a.jsoneditor-poweredBy {
  display: none;
}
</style>
